import React, { useState, useEffect } from 'react';
import { PencilIcon, TrashIcon, PlusIcon } from '@heroicons/react/24/outline';
import toast from 'react-hot-toast';
import { packageTypeService } from '../../services/cityService';

const PackageTypeList = ({ onEdit, onAdd }) => {
  const [packageTypes, setPackageTypes] = useState([]);
  const [loading, setLoading] = useState(true);



  useEffect(() => {
    fetchPackageTypes();
  }, []);

  const fetchPackageTypes = async () => {
    try {
      setLoading(true);
      const response = await packageTypeService.getPackageTypes();
      console.log('PackageTypeList - Full response:', response);
      const packageTypesData = response.package_types || response.packageTypes || response;
      console.log('PackageTypeList - Extracted data:', packageTypesData);
      
      // Ensure each package type has the required properties with fallbacks
      const normalizedPackageTypes = Array.isArray(packageTypesData) ? packageTypesData.map(packageType => ({
        ...packageType,
        description: packageType.description || ''
      })) : [];
      
      console.log('PackageTypeList - Normalized data:', normalizedPackageTypes);
      setPackageTypes(normalizedPackageTypes);
    } catch (error) {
      console.error('Error fetching package types:', error);
      setPackageTypes([]);
      toast.error('Failed to load package types');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (packageTypeId) => {
    if (window.confirm('Are you sure you want to delete this package type? This action cannot be undone.')) {
      try {
        await packageTypeService.deletePackageType(packageTypeId);
        setPackageTypes((packageTypes || []).filter(packageType => packageType.id !== packageTypeId));
        toast.success('Package type deleted successfully');
      } catch (error) {
        console.error('Error deleting package type:', error);
        toast.error('Failed to delete package type');
      }
    }
  };


  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <div className="overflow-hidden">
      <div className="px-6 py-4 border-b border-gray-200 flex justify-between items-center">
        <h3 className="text-lg font-medium text-gray-900">Package Types ({(packageTypes || []).length})</h3>
        <button
          onClick={onAdd}
          className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
        >
          <PlusIcon className="h-4 w-4 mr-2" />
          Add Package Type
        </button>
      </div>
      
      <div className="divide-y divide-gray-200">
        {(packageTypes || []).map((packageType) => (
          <div key={packageType.id} className="p-6 hover:bg-gray-50 transition-colors">
            <div className="flex items-start justify-between">
              <div className="flex-1">
                <div className="flex items-center space-x-3">
                  <h4 className="text-lg font-medium text-gray-900">{packageType.name}</h4>
                </div>
                
                {packageType.description && (
                  <p className="text-sm text-gray-600 mt-2 max-w-2xl">
                    {packageType.description}
                  </p>
                )}
                
                <div className="mt-3 flex items-center text-sm text-gray-500">
                  <span>Created: {new Date(packageType.created_at).toLocaleDateString()}</span>
                </div>
              </div>
              
              <div className="flex items-center space-x-2 ml-4">
                
                <button
                  onClick={() => onEdit(packageType)}
                  className="inline-flex items-center p-2 border border-gray-300 rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                >
                  <PencilIcon className="h-4 w-4" />
                </button>
                
                <button
                  onClick={() => handleDelete(packageType.id)}
                  className="inline-flex items-center p-2 border border-gray-300 rounded-md text-red-700 bg-white hover:bg-red-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                >
                  <TrashIcon className="h-4 w-4" />
                </button>
              </div>
            </div>
          </div>
        ))}
        
        {(packageTypes || []).length === 0 && (
          <div className="p-6 text-center">
            <p className="text-gray-500">No package types found. Click "Add Package Type" to create one.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default PackageTypeList; 